import React, { useState, useEffect } from "react";
import { BQLink } from "../../atoms/bqlink";
import PropTypes from "prop-types";
import EmptyState from "../empty-state";
import { FourStarIcon } from "../../atoms/material-icons";
import { useSelector } from "react-redux";
import get from 'lodash/get';
import "./markets-news.m.css";
import { loadMoreInteraction } from '../../../helpers/datalayer-utils';

const WidgetMarketNews = ({ newsData = [], moreRef }) => {
  const requiredMarketsNews = newsData?.slice(0, 5);
  const [initialLoading, setInitialLoading] = useState(true);
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  const showMoreNewsHandler = () => {
    const element = document.getElementById("more-from-markets");

    if (element) {
      const scrollOffset = 150;
      const scrollPosition =
        element.getBoundingClientRect().top + window.scrollY - scrollOffset;
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }
  };

  return requiredMarketsNews && requiredMarketsNews?.length > 0 ? (
    <div styleName="markets-news-container">
      {requiredMarketsNews?.slice(0, 1).map((news, index) => (
        <BQLink href={new URL(news?.link)?.pathname} key={index}>
          <div styleName="image-container">
            <img src={news?.thumb_image + '?downsize=383:233'} alt="thumb image" styleName={`thumb-image ${imgLoaded ? 'loaded' : 'not-loaded'}`} onLoad={() => setImgLoaded(true)} />
            {!imgLoaded && (
              <div styleName="image-placeholder"></div>
            )}
            <h2 styleName="image-overlay">{news?.title}
              {news?.tags?.includes('Research Reports') && (
                <span className="exclusive-icon">
                  <FourStarIcon color="#CE9445" size="14px" />
                </span>
              )}
            </h2>
          </div>
        </BQLink>
      ))}
      <div styleName="news-container">
        {requiredMarketsNews?.slice(1, 5).map((news, index) => (
          <p styleName="news-item" key={index}>
            <BQLink href={new URL(news?.link)?.pathname}>
              {news?.title}
              {news?.tags?.includes('Research Reports') && (
                <span className="exclusive-icon">
                  <FourStarIcon color="#CE9445" size="14px" />
                </span>
              )}
            </BQLink>
          </p>
        ))}
        <button
          styleName="market-news-btn"
          onClick={() => {
            loadMoreInteraction('Show All Market News', userData, pageType, 'market-news');
            showMoreNewsHandler();
            moreRef();
          }}
        >
          Show All Market News
        </button>
      </div>
    </div>
  ) : (
    <div styleName="no-data-container-ext">
      {initialLoading ? (
        <div styleName="loading-container"></div>
      ) : (
        <div styleName="no-data-container-int">
          <EmptyState />
        </div>
      )}
    </div>
  );
};

WidgetMarketNews.propTypes = {
  newsData: PropTypes.array,
  loadingStatus: PropTypes.bool,
};

export default WidgetMarketNews;
